import(/* webpackMode: "eager" */ "/test-project/app/global-error.tsx")